<main class="main">
    <div class="container">
        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">URL Instances and Schedules List</h1>
        </div>
        <div class="card-body">
            <form #filterForm="ngForm" class="navbar-form" class="form-floating">
                <div class="row m-0  searchRecordWrapper">
                    <p class="error textError m-0" *ngIf="errorMessage!=null">
                        {{errorMessage}}
                    </p>
                  
                    <!-- <div class="col-3  mt-4">
                        <div class="form-floating">
                            <input type="number" class="form-control" id="txtDocId" min="0" placeholder="URLConfigurationMasterID"
                            name="URLConfigurationMasterID" [(ngModel)]="pagination.URLConfigurationMasterID"
                            [ngModelOptions]="{standalone: true}">
                            <label for="txtClientMasterId">URL Configuration Master ID</label>
                        </div>
                    </div> -->

                    <div class="col-3  mt-4">
                        <div class="form-floating">
                            <select class="form-select form-control" id="txtClientMasterId"
                                aria-label="Floating label select example" [(ngModel)]="clientMasterId"
                                [ngModelOptions]="{standalone: true}">
                                <option selected disabled value='null'></option>
                                <option value="{{data?.ClientMasterID}}" *ngFor="let data of clientMasterOptionsList">
                                    {{data?.ClientName}}</option>
                            </select>
                            <label for="txtClientMasterId">Client Master Name</label>
                        </div>
                    </div>
                    <div class="col-3 mt-4">
                        <div class="form-floating">
                            <input type="number" class="form-control" id="txtDocId" min="0" placeholder="MasterSheetID"
                                name="MasterSheetID" [(ngModel)]="pagination.masterSheetId"
                                [ngModelOptions]="{standalone: true}">
                            <label for="txtDocId">Master Sheet Id</label>
                        </div>
                        <p *ngIf="validationError" class="text-danger mt-2">{{ validationError }}</p>
                    </div>
                    <div class="col-3 mt-4">
                        <div class="form-floating">
                            <input type="number" class="form-control" id="txtDocId" min="0"
                                placeholder="URLConfigurationMasterID" name="URLConfigurationMasterID"
                                [(ngModel)]="pagination.URLConfigurationMasterID" [ngModelOptions]="{standalone: true}">
                            <label for="txtDocId">URLConfiguration Master Id</label>
                        </div>
                    </div>
                    <div class="col-3 mt-4">
                        <div class="form-floating mb-3 datePicker">
                            <input type="text" placeholder="Process Date" class="form-control" bsDatepicker
                                [bsConfig]="{ isAnimated: true ,dateInputFormat: 'MM/DD/YYYY'}"
                                [(ngModel)]="ProcessDate" [ngModelOptions]="{standalone: true}" #s1="bsDatepicker"
                                readonly>
                            <label for="txtUrl">Process Date</label>
                            <span class="input-group-text" (click)="s1.toggle()"><i class="fa fa-calendar"></i></span>
                        </div>
                    </div>

                    <div class="col-12 mt-3">
                        <div class="d-flex">
                            <button class="btn btn-primary smallBtn" type="submit" (click)="Search(filterForm)"
                                style="height: 47px !important;">Search</button>
                            <!-- <button class="btn btn-primary smallBtn" style="height: 47px !important;"
                                (click)="ExportToXLS()">Export</button> -->
                            <button class="btn btn-default smallBtn" style="height: 47px !important;"
                            (click)="Reset()">Reset</button>

                            <div class="form-check" style = "margin-left: 20px;">
                                <input class="form-check-input" type="checkbox" id="wrapText" name="wrapText"
                                 [(ngModel)]="wrapText" [ngModelOptions]="{standalone: true}">
                                <label class="form-check-label p-0">Wrap Text</label>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">URL Schedules</h1>
        </div>
        <div class="card-body rlSearchCard scrollTo">
            <div class="row m-0">
                <!-- <h6 class="text-center" *ngIf="urlInstancesAndSchedulesSearchList1?.length==0">No URL Schedules Records found.
                </h6> -->
                <div class="col-12 table-responsive">
                    <table class="table table-bordered" [ngClass]="{'wrapTable':wrapText==true}">
                        <thead>
                            <tr style="border-bottom-width: 0px">
                                <th *ngIf="columnList[0].checked" style="width: 5%; text-align: center;min-width: 120px;">
                                    URL Detail ID
                                </th>                                
                                <th *ngIf="columnList[1].checked" style="width: 5%; text-align: center;min-width: 120px;">
                                    Schedule Master ID
                                </th>
                                <th *ngIf="columnList[2].checked" style="width: 5%; text-align: center; min-width: 200px;">
                                    Schedule Name
                                </th>
                                <th *ngIf="columnList[3].checked" style="width: 5%; text-align: center; min-width: 120px;" >
                                    Created On
                                </th>
                                <th *ngIf="columnList[4].checked" style="width: 5%; text-align: center; min-width: 120px;">
                                    Last Updated On
                                </th>
                                <th *ngIf="columnList[5].checked" style="width: 5%; text-align: center; min-width: 120px;">
                                    Schedule Start Date
                                </th>
                                <!-- <th style="width:5%;min-width: 190px;text-align: center;" rowspan="2">Action
                                    </th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="urlInstancesAndSchedulesSearchList1?.length==0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-top: 70px; padding-bottom: 70px;">
                                    <h6 class="text-center" style="color: red;" *ngIf="urlInstancesAndSchedulesSearchList1?.length==0">No Record Found
                                    </h6>
                                </td>
                            </tr>
                            <tr *ngFor="let data of urlInstancesAndSchedulesSearchList1;let i=index;"
                                [style.background-color]="data?.ColorCode!='rgb(0 0 0)' || data?.ColorCode!='#000000' ? data?.ColorCode : null">

                                <td *ngIf="columnList[0].checked" style="width: 10%; text-align:center" class="ellipsis"
                                    title="{{data?.URLDetailID}}">
                                    {{data?.URLDetailID}}</td>
                                <td *ngIf="columnList[1].checked" style="width:10%; text-align:center" class="ellipsis"
                                    title="{{data?.ScheduleMasterID}}">
                                    {{data?.ScheduleMasterID}}
                                </td>
                                <td *ngIf="columnList[2].checked" style="width:5%; text-align: center;" class="ellipsis"
                                    title=" {{data?.ScheduleName}}">
                                    {{data?.ScheduleName}}
                                </td>
                                <!-- <td *ngIf="columnList[3].checked" style="width:5%;" class="ellipsis"
                                    title=" {{data?.CreatedOn}}">
                                    {{data?.CreatedOn}}
                                </td>
                                <td *ngIf="columnList[4].checked" style="width:5%;" class="ellipsis"
                                    title=" {{data?.UpdatedOn}}">
                                    {{data?.UpdatedOn}}
                                </td> -->

                                <td *ngIf="columnList1[3].checked" style="width:5%; text-align: center;" class="ellipsis"
                                    title="{{data?.CreatedOn|date:'MM/dd/YYYY'}}">{{data?.CreatedOn|date:'MM/dd/YYYY'}}
                                </td>
                                <td *ngIf="columnList1[4].checked" style="width:5%; text-align: center;" class="ellipsis"
                                    title="{{data?.UpdatedOn|date:'MM/dd/YYYY'}}">{{data?.UpdatedOn|date:'MM/dd/YYYY'}}
                                </td>

                                <td *ngIf="columnList[5].checked" style="width:5%; text-align: center;" class="ellipsis"
                                    title=" {{data?.ScheduleStartDate}}">
                                    {{data?.ScheduleStartDate}}
                                </td>
                            <tr
                                *ngIf="urlInstancesAndSchedulesSearchList1?.length<=4 && urlInstancesAndSchedulesSearchList1?.length!=0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 142px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- </perfect-scrollbar> -->

                </div>


            </div>

        </div>
        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">URL Instances</h1>
        </div>
        <div class="card-body rlSearchCard scrollTo">
            <div class="row m-0">
                <!-- <h6 class="text-center" *ngIf="urlInstancesAndSchedulesSearchList2?.length==0">No URL Instances Records
                    found.
                </h6> -->
                <div class="col-12 table-responsive">
                    <table class="table table-bordered" [ngClass]="{'wrapTable':wrapText==true}">
                        <thead>
                            <tr style="border-bottom-width: 0px">
                                
                                <th *ngIf="columnList1[0].checked"
                                    style="width: 5%; text-align: center;min-width: 210px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                    URL Configuration Master ID 
                                    <span><i class="fa fa-sort"(click)="sortData('UrlCD')"></i></span>   
                                </div>                              
                                </th>
                           
                                <th *ngIf="columnList1[1].checked" style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                    Crawling Date
                                
                                    <span ><i class="fa fa-sort"(click)="sortData('CrawlingDate')"></i></span>
                                </div>
                                </th>
                                <th *ngIf="columnList1[2].checked" style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                    Crawling Status
                                    <span ><i class="fa fa-sort"(click)="sortData('CrawlingStatus')"></i></span>
                                    </div>
                                </th>
                                <th *ngIf="columnList1[3].checked" style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                    CE Server Name
                                    <span ><i class="fa fa-sort"(click)="sortData('CEServerName')"></i></span>
                                    </div>
                                </th>
                                <!-- <th *ngIf="columnList1[4].checked" style="width: 5%; text-align: center; min-width: 120px;">
                                    Retry Attempts
                                    <span class="float-right up"
                                        *ngIf="pagination.columnName=='RetryAttempts' && pagination.ascending">
                                        <span class="sorting"><i class="fa fa-sort-up"></i></span>
                                    </span>
                                    <span class="float-right down"
                                        *ngIf="pagination.columnName=='RetryAttempts' && !pagination.ascending">
                                        <span class="sorting"><i class="fa fa-sort-down"></i></span>
                                    </span>
                                </th> -->
                                <th *ngIf="columnList1[5].checked" style="width: 5%; text-align: center; min-width: 120px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                    Comment
                                    <span ><i class="fa fa-sort"(click)="sortData('Comment')"></i></span>
                                    </div>
                                </th>
                                <th *ngIf="columnList1[6].checked" style="width: 5%; text-align: center; min-width: 200px;" >
                                    <div class="d-flex justify-content-between align-items-center">
                                    Created On
                                    <span ><i class="fa fa-sort"(click)="sortData('CreatedOn')"></i></span>
                                    </div>
                                </th>
                                <th *ngIf="columnList1[7].checked" style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                    Last Updated On
                                    <span ><i class="fa fa-sort"(click)="sortData('CreatedOn')"></i></span>
                                    </div>
                                </th>
                                <th *ngIf="columnList1[8].checked" style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                    Mastersheet ID
                                    <span ><i class="fa fa-sort"(click)="sortData('MastersheetId')"></i></span>
                                    </div>
                                </th>       
                                <th *ngIf="columnList1[9].checked" style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                    Push to CMS
                                    <span ><i class="fa fa-sort"(click)="sortData('PushToCMS')"></i></span>
                                    </div>
                                </th>      
                                <th *ngIf="columnList1[10].checked" style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                    Reg Lake Status
                                    <span ><i class="fa fa-sort"(click)="sortData('StatusName')"></i></span>
                                    </div>
                                </th>    
                                <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center">
                                    Crawling Completed On    
                                    <span ><i class="fa fa-sort"(click)="sortData('CrawlingCompletedOn')"></i></span>    
                                    </div>                            
                                </th>                                                       
                            </tr>
                            <tr>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Job ID"[ngModelOptions]="{standalone: true}" [(ngModel)]="filters.urlConfigurationMasterID"
                                                (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Job ID"[ngModelOptions]="{standalone: true}" [(ngModel)]="filters.crawlingDate"
                                                (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Job ID"[ngModelOptions]="{standalone: true}" [(ngModel)]="filters.crawlingStatus"
                                                (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Job ID"[ngModelOptions]="{standalone: true}" [(ngModel)]="filters.ceServerName"
                                                (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Job ID"[ngModelOptions]="{standalone: true}" [(ngModel)]="filters.comment"
                                                (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Job ID"[ngModelOptions]="{standalone: true}" [(ngModel)]="filters.createdOn"
                                                (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Job ID"[ngModelOptions]="{standalone: true}" [(ngModel)]="filters.updatedOn"
                                                (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Job ID"[ngModelOptions]="{standalone: true}" [(ngModel)]="filters.mastersheetId"
                                                (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Job ID" [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.pushToCMS"
                                                (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Job ID" [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.statusName"
                                                (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form class="searchWrapperForm">
                                        <div class="d-flex">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" placeholder="Filter Job ID"[ngModelOptions]="{standalone: true}" [(ngModel)]="filters.crawlingCompletedOn"
                                                (input)="applyFilters()">
                                                <label for="txtEmail">Search</label>
                                            </div>
                                        </div>
                                    </form>
                                </th>

                                </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="urlInstancesAndSchedulesSearchList2?.length==0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-top: 70px; padding-bottom: 70px;">
                                    <h6 class="text-center" style="color: red;" *ngIf="urlInstancesAndSchedulesSearchList2?.length==0">No Record Found
                                    </h6>
                                </td>
                            </tr>
                            <tr *ngFor="let data of filteredData;let i=index;"
                                [style.background-color]="data?.ColorCode!='rgb(0 0 0)' || data?.ColorCode!='#000000' ? data?.ColorCode : null">

                                <td *ngIf="columnList1[0].checked" style="width: 10%; text-align:center"
                                    class="ellipsis" title="{{data?.URLConfigurationMasterID}}">
                                    {{data?.URLConfigurationMasterID}}</td>
                                <td *ngIf="columnList1[1].checked" style="width:5%; text-align: center;" class="ellipsis"
                                    title=" {{data?.CrawlingDate|date:'MM/dd/YYYY'}}">
                                    {{data?.CrawlingDate|date:'MM/dd/YYYY'}}
                                </td>
                                <td *ngIf="columnList1[2].checked" style="width:5%; text-align: center;" class="ellipsis"
                                    title=" {{data?.CrawlingStatus}}">
                                    {{data?.CrawlingStatus}}
                                </td>
                                <td *ngIf="columnList1[3].checked" style="width:5%; text-align: center;" class="ellipsis"
                                    title=" {{data?.CEServerName}}">
                                    {{data?.CEServerName}}
                                </td>
                                <!-- <td *ngIf="columnList1[4].checked" style="width:5%; text-align: center;" class="ellipsis"
                                    title=" {{data?.RetryAttempts}}">
                                    {{data?.RetryAttempts}}
                                </td>             -->
                                <td *ngIf="columnList1[5].checked" style="width:5%; text-align: center;" class="ellipsis"
                                    title=" {{data?.Comment}}">
                                    {{data?.Comment}}
                                </td>                                                        
                                <td *ngIf="columnList1[6].checked" style="width:5%; text-align: center;" class="ellipsis"
                                    title="{{data?.CreatedOn|date:'MM/dd/YYYY'}}">{{data?.CreatedOn|date:'MM/dd/YYYY'}}
                                </td>
                                <td *ngIf="columnList1[7].checked" style="width:5%; text-align: center;" class="ellipsis"
                                    title="{{data?.UpdatedOn|date:'MM/dd/YYYY'}}">{{data?.UpdatedOn|date:'MM/dd/YYYY'}}
                                </td>
                                <td *ngIf="columnList1[8].checked" style="width:5%; text-align: center;" class="ellipsis"
                                    title=" {{data?.MastersheetId}}">
                                    {{data?.MastersheetId}}
                                </td>   
                                <td *ngIf="columnList1[9].checked" style="width:5%; text-align: center;" class="ellipsis"
                                    title=" {{data?.PushToCMS}}">
                                    {{data?.PushToCMS}}
                                </td>   
                                <td *ngIf="columnList1[10].checked" style="width:5%; text-align: center;" class="ellipsis"
                                    title=" {{data?.StatusName}}">
                                    {{data?.StatusName}}
                                </td>                                                                  
                                <td style="width:5%; text-align: center;" class="ellipsis"
                                    title=" {{data?.CrawlingCompletedOn|date:'MM/dd/YYYY'}}">
                                    {{data?.CrawlingCompletedOn|date:'MM/dd/YYYY'}}
                                </td>  
                            </tr>
                            <tr
                                *ngIf="urlInstancesAndSchedulesSearchList2?.length<=4 && urlInstancesAndSchedulesSearchList2?.length!=0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 142px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- </perfect-scrollbar> -->

                </div>
            </div>
        </div>
    </div>
</main>

<app-loader [showLoader]="showLoader"></app-loader>
<notifier-container></notifier-container>